import React from 'react';
import { UserProvider } from './context/UserContext';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PageLayout from './Components/layout/PageLayout';
import PublicHome from './Components/pages/Public pages/PublicHome';
import Contato from './Components/pages/Public pages/Contato';
import PoliticaPrivacidade from './Components/pages/Public pages/PoliticaPrivacidade';
import QuemSomos from './Components/pages/Public pages/QuemSomos';
import TermosServico from './Components/pages/Public pages/TermosServico';
import Login from './Components/pages/Public pages/Login';
import HomeAdm from './Components/pages/HomeAdm';
import NovoCadastro from './Components/pages/NovoCadastro';
import GerenciarCadastros from './Components/pages/GerenciarCadastros';
import EditarCadastro from './Components/pages/EditarCadastro';
import Historico from './Components/pages/Historico';
import Armario from './Components/pages/Armario';
import Suporte from './Components/pages/Suporte';
import ExclusaoDados from './Components/pages/Public pages/ExclusaoDados'

// Configuração de Links Públicos
const publicLinks = [
  { label: 'Quem Somos', path: '/quem-somos' },
  { label: 'Política de Privacidade', path: '/politica-de-privacidade' },
  { label: 'Contato', path: '/contato' },
  { label: 'Termos de Serviço', path: '/termos-de-servico' },
  { label: 'Exclusão de Dados', path: '/exclusao-de-dados' },
  { label: 'Sistema Gestor', path: '/login' }
];

// Configuração de Links Privados
const privateLinks = [
  { label: 'Home', path: '/home-adm' },
  {
    label: 'Usuário',
    submenu: [
      { label: 'Novo Cadastro', path: '/usuario/novo-cadastro' },
      { label: 'Gerenciar Cadastros', path: '/usuario/gerenciar-cadastros' },
    ],
  },
  {
    label: 'Encomendas',
    submenu: [
      { label: 'Histórico', path: '/encomendas/historico' },
    ],
  },
  { label: 'Armário', path: '/armario' },
  { label: 'Suporte', path: '/suporte' },
];

function App() {
  return (
    <UserProvider>
      <Router>
        <Routes>
          {/* Páginas Públicas */}
          <Route
            path="/"
            element={<PageLayout title="Bem-vindo" links={publicLinks}><PublicHome /></PageLayout>}
          />
          <Route
            path="/quem-somos"
            element={<PageLayout title="Quem Somos" links={publicLinks}><QuemSomos /></PageLayout>}
          />
          <Route
            path="/politica-de-privacidade"
            element={<PageLayout title="Política de Privacidade" links={publicLinks}><PoliticaPrivacidade /></PageLayout>}
          />
          <Route
            path="/contato"
            element={<PageLayout title="Contato" links={publicLinks}><Contato /></PageLayout>}
          />
          <Route
            path="/termos-de-servico"
            element={<PageLayout title="Termos de Serviço" links={publicLinks}><TermosServico /></PageLayout>}
          />
          <Route
            path="/exclusao-de-dados"
            element={<PageLayout title="Exclusão de Dados" links={publicLinks}><ExclusaoDados /></PageLayout>}
          />
          <Route
            path="/login"
            element={<PageLayout title="Login" links={publicLinks}><Login /></PageLayout>}
          />

          {/* Páginas Privadas */}
          <Route
            path="/home-adm"
            element={<PageLayout title="Home Administrador" links={privateLinks}><HomeAdm /></PageLayout>}
          />
          <Route
            path="/usuario/novo-cadastro"
            element={<PageLayout title="Novo Cadastro" links={privateLinks}><NovoCadastro /></PageLayout>}
          />
          <Route
            path="/usuario/gerenciar-cadastros"
            element={<PageLayout title="Gerenciar Cadastros" links={privateLinks}><GerenciarCadastros /></PageLayout>}
          />
          <Route
            path="/usuario/gerenciar-cadastros/editar/:cD_CLI"
            element={<PageLayout title="Editar Cadastro" links={privateLinks}><EditarCadastro /></PageLayout>}
          />
          <Route
            path="/encomendas/historico"
            element={<PageLayout title="Histórico" links={privateLinks}><Historico /></PageLayout>}
          />
          <Route
            path="/armario"
            element={<PageLayout title="Lotação do Armário Inteligente" links={privateLinks}><Armario /></PageLayout>}
          />
          <Route
            path="/suporte"
            element={<PageLayout title="Suporte" links={privateLinks}><Suporte /></PageLayout>}
          />
        </Routes>
      </Router>
    </UserProvider>
  );
}

export default App;
